import { render, staticRenderFns } from "./UxbridgeCity.vue?vue&type=template&id=318dd093&scoped=true&"
import script from "./UxbridgeCity.vue?vue&type=script&lang=js&"
export * from "./UxbridgeCity.vue?vue&type=script&lang=js&"
import style0 from "./UxbridgeCity.vue?vue&type=style&index=0&id=318dd093&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318dd093",
  null
  
)

export default component.exports